<template>
    <div style="background-color: rgb(21,21,21);z-index: 10001;height: 100%">
        <div style="width: 100%;height: 58px;background-color: #2185d0">
            <h3 class="ui header"
                style="color: white; line-height: 58px; text-align: left; margin-left: 15pt; margin-bottom: 0"
            >
                {{headerText}}
            </h3>
        </div>
        <template v-for="{id} in items">
            <div v-show="id===selectedItem" style="width: 100%;height: calc(100% - 61px)">
                <slot :name="id"></slot>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: false
            },
            items: {
                type: Array,
                default: () => []
            },
            selectedItem: {
                type: Number,
                default: null
            }
        },
        data() {
            return {}
        },
        computed: {
            headerText: function () {
                const selectedItem = this.items.filter(({id}) => id === this.selectedItem)[0];
                return selectedItem ? selectedItem.label : null
            }
        },
        methods: {},

        components: {}

    }
</script>

<style scoped>

</style>
